import React, { useCallback, useContext } from 'react';
import ReactDOM from 'react-dom';

import { lightFormat as formatDate } from 'date-fns';
import { CalendarContext } from '../../context/CalendarContext.jsx';

import SvgDefaultFilter from '../../../../svg/icons/default-filter.svg';

import FilterDialog from '../FilterDialog/FilterDialog.jsx';
import FilterPreviewSwitch from '../FilterPreviewSwitch/FilterPreviewSwitch.jsx';
import FilterRangeSwitch from '../FilterRangeSwitch/FilterRangeSwitch.jsx';

const CalendarFilterModal = ({ isOpen, contentId, closeLabel }) =>
  ReactDOM.createPortal(
    <kpn-modal-body modalId={contentId} closeLabel={closeLabel} state={isOpen ? 'open' : 'close'}>
      {isOpen && <FilterDialog />}
    </kpn-modal-body>,
    document.body
  );

function CalendarFilter() {
  const { config, filter, toggleOpen, filterCount, isOpen, hasDateRange } = useContext(CalendarContext);

  const DateRange = useCallback(
    () => (
      <div data-row="xxs" className="calendar-filter__date-range">
        <span className="text text--small-link">{formatDate(filter.date.from, config.date.format)}</span>
        <span className="text text--small-link">–</span>
        <span className="text text--small-link">{formatDate(filter.date.to, config.date.format)}</span>
      </div>
    ),
    [hasDateRange]
  );

  return (
    <div className="calendar__filter">
      <div className="calendar-filter__buttons">
        {hasDateRange && <DateRange />}
        {!hasDateRange && config.dateSwitch.type === 'preview' && <FilterPreviewSwitch />}
        {!hasDateRange && config.dateSwitch.type === 'range' && <FilterRangeSwitch />}

        <kpn-modal-trigger modalId={config.contentId} onClick={toggleOpen}>
          <div data-row="xxs" className={`calendar-filter__trigger ${filterCount > 0 ? 'has-filter' : ''}`}>
            <SvgDefaultFilter />

            <span className="text text--link calendar-filter__trigger-label--mobile">({filterCount})</span>
            <span className="text text--link calendar-filter__trigger-label--desktop">{config.labels.filter}</span>
          </div>
        </kpn-modal-trigger>
      </div>

      <CalendarFilterModal isOpen={isOpen} contentId={config.contentId} closeLabel={config.labels.close} />
    </div>
  );
}

export default CalendarFilter;
